import React , { Component, Fragment } from 'react';
import { TextField } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

export default class FormInputText extends Component {
    constructor(props) {
        super(props);
        this.state = {
            errorText:props.errorText,
            error:props.error,
            defaultValue:this.props.defaultValue,
            focus: false
        };
        this.handleChange = this.handleChange.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
    }
    
    UNSAFE_componentWillReceiveProps(next_props) {
        if(next_props.initial !== undefined && next_props.initial){
            this.setState({ error: next_props.error, errorText:'',defaultValue:next_props.defaultValue });
        }else{
            this.setState({ error: next_props.error});
        }
    }

    handleChange = (event) => {
        this.setState({defaultValue:event.target.value});
        if(event.target.value === ''){
            this.setState({errorText: this.props.placeholder,error:true});
        }else{
            //se valida que no ingrese "ñ" https://sharing.clickup.com/30921813/t/h/85zrqenk4/Y43MZPSU8ADY6SC
            // 

            if (this.props.label === 'Nombre' || this.props.label === 'Apellido' ) {
                if (event.target.value.match('^[ A-Za-z.-]*$')) {
                    this.setState({errorText: '',error:false});
                } else {
                    //Se vacia el campo en caso de error y se cambia el texto de error
                    this.setState({errorText: 'Ingrese solo letras sin caracteres especiales como ñ o tildes.', error:true, defaultValue:''});
                }
            } else {
                if (event.target.value.match('^[ A-Za-zäÄëËïÏöÖüÜáéíóúáéíóúÁÉÍÓÚÂÊÎÔÛâêîôûàèìòùÀÈÌÒÙñÑ.-]*$')) {
                    this.setState({errorText: '',error:false});
                } else {
                    //Se vacia el campo en caso de error y se cambia el texto de error
                    this.setState({errorText: 'Ingrese solo letras.', error:true, defaultValue:''});
                }
            }



            
        }
    }

    onBlur() { setTimeout(() => {if (this.state.focus){this.setState({focus: false});}}, 0) }

    onFocus() { if (!this.state.focus) {this.setState({focus: true});} }

    render() {
        const OnFocusHideFixedElements = withStyles({"@global": {
            "body .headroom":{'@media (max-width: 960px)': {transform: "translate3d(0px, -100%, 0px)!important"}}
        }})(() => null);
        return (
            <Fragment>
            {this.state.focus && <OnFocusHideFixedElements/>}
            <TextField fullWidth InputLabelProps={{ shrink: true }} variant="outlined"
                className={`InputForm ${this.props.classNameCustom}`}
                //{...this{.props}
                inputProps={
                    this.props.label === 'Nombre' || this.props.label === 'Nombre(s)'?
                    {maxLength: 15}
                    :this.props.label==='Apellido(s)' || 'Apellido'?
                    {maxLength: 15}
                    :{maxLength: 100}}
                error={this.state.error}
                id={this.props.id}
                label={this.props.label}
                placeholder={this.props.placeholder}
                helperText={this.state.errorText}
                onChange={this.handleChange}
                value={this.state.defaultValue}
                name={this.props.name}
                disabled={this.props.disabled}
                required={this.props.required}
                autoComplete={this.props.autoComplete}
                onFocus={this.onFocus}
                onBlur={this.onBlur}
            />
             </Fragment>
        )
    }
}
